import { ColumnDynamicProperties } from './column-dynamic-properties.interface';
import { ColumnParams } from './column-params.interface';
import { JournalRecord } from './journal-record.interface';

export interface JournalFactory {
  // формирования объекта-значения с параметрами для запроса данных из источника данных
  makeQueryRequestConfig(this: void, config: QueryRequestSourceData): QueryRequestConfig;
  // получение объект-значения с пустыми значениями ответа по умолчанию
  getEmptyJournalQueryResult(this: void): JournalQueryResult;
}

export interface QueryRequestSourceData {
  journalCode: string | null;
  sort: ColumnParams[];
  filters?: any[];
}

export interface QueryRequestConfig {
  journalCode: string | null;
  filters?: any[];
}

export interface JournalQueryResult {
  rowsCount: number;
  recordList: JournalRecord[];
  hasErrors: boolean;
}
